import React from 'react';
import { CalendarDays, Clock } from 'lucide-react';

/**
 * Компонент ввода диапазона дат или количества дней
 */
const DateRangeSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  const renderDateDifferenceFields = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Дата начала */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CalendarDays className="w-4 h-4 mr-2 text-cyan-500" />
          Дата начала
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>

      {/* Дата окончания */}
      <div>
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CalendarDays className="w-4 h-4 mr-2 text-cyan-500" />
          Дата окончания
        </label>
        <input
          type="date"
          id="endDate"
          name="endDate"
          value={formData.endDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.endDate ? 'input-error' : ''}`}
        />
        {errors.endDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.endDate}
          </p>
        )}
      </div>

      {/* Ошибка порядка дат */}
      {errors.dateOrder && (
        <div className="col-span-full">
          <p className="text-xs text-red-500 dark:text-red-400">
            {errors.dateOrder}
          </p>
        </div>
      )}

      {/* Включать ли конечную дату */}
      <div className="col-span-full mt-2">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeEndDate"
            checked={formData.includeEndDate}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Включить конечную дату в расчет количества дней
          </span>
        </label>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
          Если включено, то конечная дата будет считаться как полный день. Например, с 1 по 2 января будет равно 2 дням.
        </p>
      </div>
    </div>
  );

  const renderAddSubtractFields = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Дата начала */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CalendarDays className="w-4 h-4 mr-2 text-cyan-500" />
          {formData.calculationType === 'add' ? 'Начальная дата' : 'Исходная дата'}
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>

      {/* Количество дней */}
      <div>
        <label htmlFor="daysToAddSubtract" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Clock className="w-4 h-4 mr-2 text-cyan-500" />
          {formData.calculationType === 'add' ? 'Добавить дней' : 'Вычесть дней'}
        </label>
        <input
          type="number"
          id="daysToAddSubtract"
          name="daysToAddSubtract"
          min="1"
          max="3650"
          value={formData.daysToAddSubtract}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.daysToAddSubtract ? 'input-error' : ''}`}
          placeholder="Введите количество дней"
        />
        {errors.daysToAddSubtract && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.daysToAddSubtract}
          </p>
        )}
      </div>
    </div>
  );

  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-5 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CalendarDays className="w-5 h-5 mr-2 text-cyan-500" />
        {formData.calculationType === 'difference' 
          ? 'Диапазон дат' 
          : formData.calculationType === 'add'
            ? 'Добавление дней к дате'
            : 'Вычитание дней из даты'
        }
      </h3>
      
      {formData.calculationType === 'difference' 
        ? renderDateDifferenceFields() 
        : renderAddSubtractFields()
      }
    </div>
  );
};

export default DateRangeSection;